import { CommonModule, CurrencyPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TableModule } from 'primeng/table';
import { StaffDisputeLine } from '../../services/staff-dispute.service';

@Component({
    selector: 'app-dispute-items-card',
    standalone: true,
    imports: [CommonModule, CurrencyPipe, TableModule],
    template: `
        <div class="dispute-card items-card">
            <h3 class="dispute-section-title">Disputed Items</h3>
            <p-table [value]="lines" styleClass="dispute-table dispute-items-table" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Item</th>
                        <th>Claimed Qty</th>
                        <th>Ordered Qty</th>
                        <th>Reason</th>
                        <th class="amount-col">Amount</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-line>
                    <tr>
                        <td>
                            <div class="item-name-cell">
                                <strong>{{ line.itemNumber }}</strong>
                                <span class="item-desc">{{ line.itemName }}</span>
                            </div>
                        </td>
                        <td>{{ line.claimedQty }}</td>
                        <td>{{ line.orderedQty }}</td>
                        <td><span class="reason-pill">{{ line.reason }}</span></td>
                        <td class="amount-col">
                            {{
                                line.claimAmountEur != null
                                    ? (line.claimAmountEur | currency: 'EUR' : 'symbol' : '1.2-2')
                                    : '—'
                            }}
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5" class="empty-cell">No disputed lines.</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    `,
    styles: [
        `
            .items-card {
                padding-bottom: 0.5rem;
            }
            .item-name-cell {
                display: flex;
                flex-direction: column;
                gap: 0.15rem;
                max-width: 280px;
            }
            .item-desc {
                font-size: 0.8rem;
                color: var(--dispute-muted, var(--text-color-secondary));
            }
            .reason-pill {
                display: inline-block;
                padding: 0.15rem 0.5rem;
                border-radius: 6px;
                font-size: 0.68rem;
                font-weight: 700;
                background: var(--dispute-status-rejected-bg, color-mix(in srgb, var(--p-red-500) 15%, transparent));
                color: var(--dispute-status-rejected-text, var(--p-red-700));
                border: 1px solid color-mix(in srgb, var(--p-red-500) 25%, transparent);
            }
            .amount-col {
                text-align: right;
                font-weight: 600;
                color: var(--dispute-primary, var(--primary-color));
            }
            .empty-cell {
                text-align: center;
                color: var(--dispute-muted, var(--text-color-secondary));
                padding: 1.5rem !important;
            }
        `
    ]
})
export class DisputeItemsCardComponent {
    @Input({ required: true }) lines: StaffDisputeLine[] = [];
}
